// src/tours/index.js
import { tourHome } from './homeTour';
import { tourDashboard } from './dashboardTour';
// import { tourRelatorios } from './relatoriosTour';

export const tours = {
  '/': tourHome,
  '/dashboard': tourDashboard,
//   '/relatorios': tourRelatorios,
  // ...ou use chaves como 'home', 'dashboard', etc.
};